import { apiFetch } from "./apiClient";

export async function getDevices(includeRcDevice = false) {
  const url = new URL("/api/v1/list-devices", window.location.origin);
  if (includeRcDevice) {
    url.searchParams.set("includeRcDevice", "true");
  }

  const res = await apiFetch(url.pathname + url.search);
  if (!res.ok) {
    throw new Error("Failed to fetch devices");
  }
  return res.json();
}
// This calls getDeviceDataByDeviceId on the backend
export async function getDeviceData(rcDeviceId) {
  const res = await apiFetch(`/api/v1/device-status/${rcDeviceId}`);
  if (!res.ok) {
    throw new Error("Failed to fetch device data");
  }
  return res.json();
}

// One page of the device's cleaning sessions (newest first) with their zones.
// Pass the previous page's nextBefore as `before` to load the next page.
// -> { sessions: [...], hasMore, nextBefore }
export async function getDeviceSessions(rcDeviceId, { before = null, limit = 20 } = {}) {
  const params = new URLSearchParams({ limit: String(limit) });
  if (before) params.set("before", String(before));
  const res = await apiFetch(
    `/api/v1/device-sessions/${encodeURIComponent(rcDeviceId)}?${params.toString()}`,
  );
  if (!res.ok) {
    throw new Error("Failed to fetch cleaning sessions");
  }
  return res.json();
}

export async function getDeviceCleaningData(rcDeviceId) {
  const res = await apiFetch(`/api/v1/device-cleaning-data/${rcDeviceId}`);
  if (!res.ok) {
    throw new Error("Failed to fetch device cleaning data");
  }
  return res.json();
}

// Only the device ID and room are required as a customer cannot be assigned without correct location hieracrchy being completed. This ensures the workflow is followed.
export async function assignDeviceToCustomerAndLocation(rcDeviceId, roomId) {
  const res = await apiFetch(`/api/services/service/assign-device`, {
    method: "POST",
    body: JSON.stringify({ rcDeviceId, roomId }),
  });
  if (!res.ok) {
    const errorData = await res.json();
    return {
      success: false,
      error:
        errorData.error || "Failed to assign device to customer and location",
    };
  }
  const data = await res.json();
  return { success: true, data };
}
// This will be used when creating jobs and tasks to link them to the correct device and customer.
// The function will likely need to accept a device ID and the relevant customer/location/building IDs to create the association in the database.

// Generic single-field device update; valid `field` values are enforced by the backend allowlist.
export async function updateDeviceField(rcDeviceId, field, value) {
  const res = await apiFetch(`/api/services/service/update-device-field`, {
    method: "POST",
    body: JSON.stringify({ rcDeviceId, field, value }),
  });
  if (!res.ok) {
    const errorData = await res.json();
    return {
      success: false,
      error: errorData.error || `Failed to update ${field}`,
    };
  }
  const data = await res.json();
  return { success: true, data };
}
